import React from "react";
import chevronRightIcon from "../assets/images/chevron-right.svg";
import { SanityNode } from "../config/build/models/node";
import { useParentNode } from "../hooks/useParentNode";
import useTranslations from "../hooks/useTranslations";
import { isNullOrWhiteSpace, replaceWithUnicode } from "../shared/string";
import SanityLink from "./SanityLink";

interface Props {
  startNode: SanityNode;
  className?: string;
}

const RenderBreadcrumb = (breadcrumb: SanityNode | undefined, first: boolean) => {
  const translations = useTranslations();
  const nextNode = useParentNode(breadcrumb);

  if (!breadcrumb) {
    return (
      <li key="home" className="flex items-center">
        <SanityLink className="text-brand-primary-40 text-sm no-underline hover:underline hover:text-brand-primary-60">
          {translations.home}
        </SanityLink>
      </li>
    );
  }

  return (
    <>
      {RenderBreadcrumb(nextNode, false)}
      <li key={breadcrumb.slug?.current} className="flex items-center">
        <svg width={14} height={14} className="fill-current text-neutral-75 mx-2">
          <use xlinkHref={chevronRightIcon.url} />
        </svg>
        {first ? (
          <span className="text-neutral-40 text-sm">
            {replaceWithUnicode(breadcrumb.title)}
          </span>
        ) : (
          <SanityLink
            reference={breadcrumb}
            className="text-brand-primary-40 text-sm no-underline hover:underline hover:text-brand-primary-60"
          >
            {replaceWithUnicode(breadcrumb.title)}
          </SanityLink>
        )}
      </li>
    </>
  );
};

const Breadcrumbs = ({ startNode, className }: Props) => (
  <div
    className={
      !isNullOrWhiteSpace(className)
        ? className
        : "breadcrumbs flex w-full max-w-screen-xl p-4 mx-auto text-sm mb-2 lg:mb-0"
    }
  >
    <ul className="flex">{RenderBreadcrumb(startNode, true)}</ul>
  </div>
);

export default Breadcrumbs;
